import { useEffect, useState } from "react";

// STYLES
import * as Style from "./DoorDetailsStyle";

// LIBRARIES

// MISC
import { IProps, IModalData } from "./DoorDetailsModel";
import { COLORS } from "constants/styleVariables";
import {
  DoorStatusEnum,
  EquipmentStatusEnum,
} from "models/GeneralTypes/generalTypes";
import { ISlot, ISlotEquipments, ISlotEquipmentsEdit } from "models/interfaces";

// ASSETS
import DeleteIcon from "assets/Icons/CleanIcon.svg";
import AddIcon from "assets/Icons/AddIcon.svg";

// REDUX
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { modalProps } from "slices/uiSlice";
import {
  editSlot,
  editSlotEquipments,
  getSlot,
  getSlotEquipments,
  openSlotDoor,
} from "api/lockerApi";
import { t } from "i18next";

// COMPONENTS

const DoorDetails = (props: IProps) => {
  // PROPS
  const { handleClose = () => { } } = props;

  // CONSTANTS USING HOOKS
  const [doorDetailsValue, setDoorDetailsValue] = useState<ISlot>();
  const [slotEquipmentsValues, setSlotEquipmentsValues] =
    useState<ISlotEquipments>();
  const [editOn, setEditOn] = useState(false);

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const modalPropsData = useAppSelector<IModalData>(modalProps);

  // GENERAL CONSTANTS

  console.log(modalPropsData);

  // USE EFFECT FUNCTION
  useEffect(() => {
    if (modalPropsData.door.id) {
      dispatch(getSlot(modalPropsData.door.id))
        .unwrap()
        .then((response) => {
          setDoorDetailsValue(response);
          // dispatch(getSlotEquipments(modalPropsData.door.id))
          //   .unwrap()
          //   .then((response) => {
          //     setSlotEquipmentsValues(response);
          //   });
        });
    }

    //eslint-disable-next-line
  }, [modalPropsData.door]);

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleOpenDoor = () => {
    if (doorDetailsValue.pcbSlotNumber !== 20) {
      dispatch(openSlotDoor({ slotId: doorDetailsValue.pcbSlotNumber, lockerId: modalPropsData.lockerId }))
        .unwrap()
        .then(() => {
          dispatch(getSlot(modalPropsData.door.id))
            .unwrap()
            .then((response) => {
              setDoorDetailsValue(response);
            });
        });
    }

  };

  const handlePaddle = () => {
    if (slotEquipmentsValues.paddle.status === EquipmentStatusEnum.AVAILABLE) {
      setSlotEquipmentsValues({
        ...slotEquipmentsValues,
        paddle: {
          ...slotEquipmentsValues.paddle,
          status: EquipmentStatusEnum.UNAVAILABLE,
        },
      });
    } else {
      setSlotEquipmentsValues({
        ...slotEquipmentsValues,
        paddle: {
          ...slotEquipmentsValues.paddle,
          status: EquipmentStatusEnum.AVAILABLE,
        },
      });
    }
  };

  const handleLifeJacket = () => {
    if (
      slotEquipmentsValues.lifeJacket.status === EquipmentStatusEnum.AVAILABLE
    ) {
      setSlotEquipmentsValues({
        ...slotEquipmentsValues,
        lifeJacket: {
          ...slotEquipmentsValues.lifeJacket,
          status: EquipmentStatusEnum.UNAVAILABLE,
        },
      });
    } else {
      setSlotEquipmentsValues({
        ...slotEquipmentsValues,
        lifeJacket: {
          ...slotEquipmentsValues.lifeJacket,
          status: EquipmentStatusEnum.AVAILABLE,
        },
      });
    }
  };

  const handleUnderwaterCover = () => {
    if (
      slotEquipmentsValues.waterproofCase.status ===
      EquipmentStatusEnum.AVAILABLE
    ) {
      setSlotEquipmentsValues({
        ...slotEquipmentsValues,
        waterproofCase: {
          ...slotEquipmentsValues.waterproofCase,
          status: EquipmentStatusEnum.UNAVAILABLE,
        },
      });
    } else {
      setSlotEquipmentsValues({
        ...slotEquipmentsValues,
        waterproofCase: {
          ...slotEquipmentsValues.waterproofCase,
          status: EquipmentStatusEnum.AVAILABLE,
        },
      });
    }
  };

  const handleDismiss = () => {
    setEditOn(false);
  };

  const handleSave = () => {
    let editSlotEquipmentsValues: ISlotEquipmentsEdit = {
      lifeJacket: {
        id: slotEquipmentsValues.lifeJacket.id,
        status: slotEquipmentsValues.lifeJacket.status,
      },
      paddle: {
        id: slotEquipmentsValues.paddle.id,
        status: slotEquipmentsValues.paddle.status,
      },
      waterproofCase: {
        id: slotEquipmentsValues.waterproofCase.id,
        status: slotEquipmentsValues.waterproofCase.status,
      },
    };
    dispatch(editSlotEquipments(editSlotEquipmentsValues))
      .unwrap()
      .then(() => {
        dispatch(getSlotEquipments(doorDetailsValue.id))
          .unwrap()
          .then((response) => {
            setSlotEquipmentsValues(response);
            setEditOn(false);
          });
      });
  };

  const handleChangeDoor = () => {
    let newDoorDetailsValue = {
      doorStatus: doorDetailsValue.doorStatus,
      id: doorDetailsValue.id,
      identificationNumber: doorDetailsValue.identificationNumber,
      isActive: doorDetailsValue.isActive,
      lockerId: doorDetailsValue.locker.id,
      status: doorDetailsValue.status,
    };

    if (doorDetailsValue.status === EquipmentStatusEnum.AVAILABLE) {
      newDoorDetailsValue = {
        ...newDoorDetailsValue,
        status: EquipmentStatusEnum.UNAVAILABLE,
      };
      setDoorDetailsValue({
        ...doorDetailsValue,
        status: newDoorDetailsValue.status,
      });
    } else if (doorDetailsValue.status === EquipmentStatusEnum.UNAVAILABLE) {
      newDoorDetailsValue = {
        ...newDoorDetailsValue,
        status: EquipmentStatusEnum.AVAILABLE,
      };
      setDoorDetailsValue({
        ...doorDetailsValue,
        status: newDoorDetailsValue.status,
      });
    }
    dispatch(editSlot(newDoorDetailsValue));
  };

  console.log("DOOR DETAILS VALUE", doorDetailsValue);

  return (
    <Style.DoorDetailsContainer>
      {doorDetailsValue && (
        <>
          <Style.CloseIconContainer>
            <Style.CloseIcon onClick={handleClose} />
          </Style.CloseIconContainer>
          <Style.TitlesContainer>
            <Style.TitleContainer color={COLORS.cornflowerBlue}>
              {doorDetailsValue.doorStatus === DoorStatusEnum.CLOSED &&
                doorDetailsValue.status === EquipmentStatusEnum.AVAILABLE && (
                  <Style.LockerIcon color={COLORS.cornflowerBlue} />
                )}
              {doorDetailsValue.doorStatus === DoorStatusEnum.CLOSED &&
                doorDetailsValue.status === EquipmentStatusEnum.UNAVAILABLE && (
                  <Style.LockerIcon color={COLORS.terraCotta} />
                )}
              {doorDetailsValue.doorStatus === DoorStatusEnum.CLOSED &&
                doorDetailsValue.status === EquipmentStatusEnum.RENTED && (
                  <Style.LockerIcon color={COLORS.terraCotta} />
                )}
              {doorDetailsValue.status === EquipmentStatusEnum.AVAILABLE && (
                <Style.Title>
                  {t("modal.slotDetails.slotStatus")}{" "}
                  {doorDetailsValue.identificationNumber}{" "}
                </Style.Title>
              )}
              {doorDetailsValue.status === EquipmentStatusEnum.RENTED && (
                <Style.Title color={COLORS.terraCotta}>
                  {t("modal.slotDetails.slotStatus")}{" "}
                  {doorDetailsValue.identificationNumber}{" "}
                </Style.Title>
              )}
              {doorDetailsValue.status === EquipmentStatusEnum.UNAVAILABLE && (
                <Style.Title color={COLORS.terraCotta}>
                  {t("modal.slotDetails.slotStatus")}{" "}
                  {doorDetailsValue.identificationNumber}{" "}
                </Style.Title>
              )}
            </Style.TitleContainer>
            {(doorDetailsValue.doorStatus === DoorStatusEnum.OPENED && (
              <>
                <Style.Status>
                  {t("modal.slotDetails.door")} {doorDetailsValue.doorStatus}
                </Style.Status>
                <Style.Status>
                  {doorDetailsValue.status === EquipmentStatusEnum.AVAILABLE ||
                    (doorDetailsValue.status === EquipmentStatusEnum.RENTED &&
                      doorDetailsValue.status)}
                </Style.Status>
              </>
            )) ||
              (doorDetailsValue.doorStatus === DoorStatusEnum.CLOSED && (
                <>
                  <Style.Status color={COLORS.terraCotta}>
                    {t("modal.slotDetails.door")} {doorDetailsValue.doorStatus}
                  </Style.Status>
                  <Style.Status color={COLORS.terraCotta}>
                    {doorDetailsValue.status ===
                      EquipmentStatusEnum.UNAVAILABLE ||
                      (doorDetailsValue.status === EquipmentStatusEnum.RENTED &&
                        doorDetailsValue.status)}
                  </Style.Status>
                </>
              ))}
          </Style.TitlesContainer>
          <Style.EquipmentsContainer>
            {/* <Style.SubtitleContainer>
              <Style.Subtitle>
                {t("modal.slotDetails.equipmentStatus")}
              </Style.Subtitle>
              {!editOn &&
                doorDetailsValue.status !== EquipmentStatusEnum.RENTED && (
                  <Style.ButtonContainer
                    onClick={() => setEditOn(true)}
                    variant="outlined"
                  >
                    {t("modal.slotDetails.edit")}
                  </Style.ButtonContainer>
                )}
              {editOn &&
                doorDetailsValue.status !== EquipmentStatusEnum.RENTED && (
                  <Style.ActionsContainer>
                    <Style.ButtonContainer
                      orangeColor={COLORS.terraCotta}
                      variant="outlined"
                      onClick={handleDismiss}
                    >
                      {t("modal.slotDetails.abandon")}
                    </Style.ButtonContainer>
                    <Style.ButtonContainer
                      variant="outlined"
                      onClick={handleSave}
                    >
                      {t("modal.slotDetails.save")}
                    </Style.ButtonContainer>
                  </Style.ActionsContainer>
                )}
            </Style.SubtitleContainer> */}
            <Style.EquipmentContentContainer>
              <Style.EquipmentDescriptionContainer>
                {/* <Style.EquipmentName>
                  {t("modal.slotDetails.board")}
                </Style.EquipmentName> */}
                {/* {(slotEquipmentsValues.supBoard?.status ===
                  EquipmentStatusEnum.AVAILABLE && (
                    <Style.EquipmentStatus>
                      {t(
                        `modal.slotDetails.equipment.status.${slotEquipmentsValues.supBoard?.status}`
                      )}
                    </Style.EquipmentStatus>
                  )) ||
                  (slotEquipmentsValues.supBoard?.status ===
                    EquipmentStatusEnum.UNAVAILABLE && (
                      <Style.EquipmentStatus color={COLORS.terraCotta}>
                        {t(
                          `modal.slotDetails.equipment.status.${slotEquipmentsValues.supBoard?.status}`
                        )}
                      </Style.EquipmentStatus>
                    )) ||
                  (slotEquipmentsValues.supBoard?.status ===
                    EquipmentStatusEnum.RENTED && (
                      <Style.EquipmentStatus color={COLORS.terraCotta}>
                        {t(
                          `modal.slotDetails.equipment.status.${slotEquipmentsValues.supBoard?.status}`
                        )}
                      </Style.EquipmentStatus>
                    ))} */}
              </Style.EquipmentDescriptionContainer>
            </Style.EquipmentContentContainer>
            {/* <Style.Bar></Style.Bar> */}
            <Style.EquipmentContentContainer>
              <Style.EquipmentDescriptionContainer>
                {/* <Style.EquipmentName>
                  {t("modal.slotDetails.paddle")}
                </Style.EquipmentName> */}
                {/* {(slotEquipmentsValues.paddle.status ===
                  EquipmentStatusEnum.AVAILABLE && (
                    <Style.EquipmentStatus>
                      {t(
                        `modal.slotDetails.equipment.status.${slotEquipmentsValues.paddle?.status}`
                      )}
                    </Style.EquipmentStatus>
                  )) ||
                  (slotEquipmentsValues.paddle.status ===
                    EquipmentStatusEnum.UNAVAILABLE && (
                      <Style.EquipmentStatus color={COLORS.terraCotta}>
                        {t(
                          `modal.slotDetails.equipment.status.${slotEquipmentsValues.paddle?.status}`
                        )}
                      </Style.EquipmentStatus>
                    )) ||
                  (slotEquipmentsValues.paddle.status ===
                    EquipmentStatusEnum.RENTED && (
                      <Style.EquipmentStatus color={COLORS.terraCotta}>
                        {t(
                          `modal.slotDetails.equipment.status.${slotEquipmentsValues.paddle?.status}`
                        )}
                      </Style.EquipmentStatus>
                    ))} */}
              </Style.EquipmentDescriptionContainer>
              {editOn && (
                <Style.ActionIconContainer>
                  {/* {slotEquipmentsValues.paddle.status ===
                    EquipmentStatusEnum.AVAILABLE && (
                      <Style.Icon
                        onClick={() => handlePaddle()}
                        src={DeleteIcon}
                      />
                    )}
                  {slotEquipmentsValues.paddle.status ===
                    EquipmentStatusEnum.UNAVAILABLE && (
                      <Style.Icon onClick={() => handlePaddle()} src={AddIcon} />
                    )} */}
                </Style.ActionIconContainer>
              )}
            </Style.EquipmentContentContainer>
            {/* <Style.Bar></Style.Bar> */}
            <Style.EquipmentContentContainer>
              <Style.EquipmentDescriptionContainer>
                {/* <Style.EquipmentName>
                  {t("modal.slotDetails.vest")}
                </Style.EquipmentName> */}
                {/* {(slotEquipmentsValues.lifeJacket.status ===
                  EquipmentStatusEnum.AVAILABLE && (
                    <Style.EquipmentStatus>
                      {t(
                        `modal.slotDetails.equipment.status.${slotEquipmentsValues.lifeJacket.status}`
                      )}
                    </Style.EquipmentStatus>
                  )) ||
                  (slotEquipmentsValues.lifeJacket.status ===
                    EquipmentStatusEnum.UNAVAILABLE && (
                      <Style.EquipmentStatus color={COLORS.terraCotta}>
                        {t(
                          `modal.slotDetails.equipment.status.${slotEquipmentsValues.lifeJacket.status}`
                        )}
                      </Style.EquipmentStatus>
                    )) ||
                  (slotEquipmentsValues.lifeJacket.status ===
                    EquipmentStatusEnum.RENTED && (
                      <Style.EquipmentStatus color={COLORS.terraCotta}>
                        {t(
                          `modal.slotDetails.equipment.status.${slotEquipmentsValues.lifeJacket.status}`
                        )}
                      </Style.EquipmentStatus>
                    ))} */}
              </Style.EquipmentDescriptionContainer>
              {editOn && (
                <Style.ActionIconContainer>
                  {/* {slotEquipmentsValues.lifeJacket.status ===
                    EquipmentStatusEnum.AVAILABLE && (
                      <Style.Icon
                        onClick={() => handleLifeJacket()}
                        src={DeleteIcon}
                      />
                    )}
                  {slotEquipmentsValues.lifeJacket.status ===
                    EquipmentStatusEnum.UNAVAILABLE && (
                      <Style.Icon
                        onClick={() => handleLifeJacket()}
                        src={AddIcon}
                      />
                    )} */}
                </Style.ActionIconContainer>
              )}
            </Style.EquipmentContentContainer>
            {/* <Style.Bar></Style.Bar> */}
            <Style.EquipmentContentContainer>
              <Style.EquipmentDescriptionContainer>
                {/* <Style.EquipmentName>
                  {t("modal.slotDetails.underwaterCover")}
                </Style.EquipmentName> */}
                {/* {(slotEquipmentsValues.waterproofCase.status ===
                  EquipmentStatusEnum.AVAILABLE && (
                    <Style.EquipmentStatus>
                      {t(
                        `modal.slotDetails.equipment.status.${slotEquipmentsValues.waterproofCase.status}`
                      )}
                    </Style.EquipmentStatus>
                  )) ||
                  (slotEquipmentsValues.waterproofCase.status ===
                    EquipmentStatusEnum.UNAVAILABLE && (
                      <Style.EquipmentStatus color={COLORS.terraCotta}>
                        {t(
                          `modal.slotDetails.equipment.status.${slotEquipmentsValues.waterproofCase.status}`
                        )}
                      </Style.EquipmentStatus>
                    )) ||
                  (slotEquipmentsValues.waterproofCase.status ===
                    EquipmentStatusEnum.RENTED && (
                      <Style.EquipmentStatus color={COLORS.terraCotta}>
                        {t(
                          `modal.slotDetails.equipment.status.${slotEquipmentsValues.waterproofCase.status}`
                        )}
                      </Style.EquipmentStatus>
                    ))} */}
              </Style.EquipmentDescriptionContainer>
              {editOn && (
                <Style.ActionIconContainer>
                  {/* {slotEquipmentsValues.waterproofCase.status ===
                    EquipmentStatusEnum.AVAILABLE && (
                      <Style.Icon
                        onClick={() => handleUnderwaterCover()}
                        src={DeleteIcon}
                      />
                    )}
                  {slotEquipmentsValues.waterproofCase.status ===
                    EquipmentStatusEnum.UNAVAILABLE && (
                      <Style.Icon
                        onClick={() => handleUnderwaterCover()}
                        src={AddIcon}
                      />
                    )} */}
                </Style.ActionIconContainer>
              )}
            </Style.EquipmentContentContainer>
            <Style.Bar></Style.Bar>
          </Style.EquipmentsContainer>
          <Style.ActionsContainer>
            <Style.ButtonsContainer>
              {doorDetailsValue.status === EquipmentStatusEnum.AVAILABLE && (
                <Style.ButtonContainer
                  variant="outlined"
                  onClick={handleChangeDoor}
                >
                  {t("modal.slotDetails.unavailable")}
                </Style.ButtonContainer>
              )}
              {doorDetailsValue.status === EquipmentStatusEnum.UNAVAILABLE && (
                <Style.ButtonContainer
                  variant="outlined"
                  orangeColor={COLORS.terraCotta}
                  onClick={handleChangeDoor}
                >
                  {t("modal.slotDetails.available")}
                </Style.ButtonContainer>
              )}
            </Style.ButtonsContainer>
            <Style.ButtonsContainer>
              {/* {doorDetails.openDoor === DoorStatusEnum.OPEN && (
                <Style.ButtonContainer
                  variant="outlined"
                  onClick={() => handleOpenDoor()}
                >
                  Inchisa
                </Style.ButtonContainer>
              )} */}
              {doorDetailsValue.doorStatus !== DoorStatusEnum.OPENED && (
                <Style.ButtonContainer
                  variant="outlined"
                  orangeColor={COLORS.terraCotta}
                  onClick={handleOpenDoor}
                >
                  {t("modal.slotDetails.openDoor")}
                </Style.ButtonContainer>
              )}
            </Style.ButtonsContainer>
          </Style.ActionsContainer>
        </>
      )}
    </Style.DoorDetailsContainer>
  );
};

export default DoorDetails;
